import React, { useState } from 'react';
import { Alert, AlertProps, Button } from '@mui/material';
import { FolderOpen as FolderOpenIcon } from '@mui/icons-material';
import { useIsElectron } from '../../../../context/ElectronContext';
import { useDesktopConnection } from '../../../../hooks/useDesktopConnection';
import { DesktopAppRequiredDialog } from '../../_misc/DesktopAppRequiredDialog';

interface ProjectFolderPromptProps extends AlertProps {
  onLocateProject: () => Promise<void>;
}

const ProjectFolderPrompt: React.FC<ProjectFolderPromptProps> = ({
  onLocateProject,
  ...props
}) => {
  const isElectron = useIsElectron();
  const { isConnected, isChecking } = useDesktopConnection();
  const canLocate = isElectron || isConnected;
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Alert
        {...props}
        sx={{ ...props.sx }}
        severity="info"
        action={
          canLocate ? (
            <Button
              startIcon={<FolderOpenIcon />}
              onClick={onLocateProject}
              size="small"
            >
              Locate Project
            </Button>
          ) : undefined
        }
      >
        {isChecking ? (
          'Checking for desktop app\u2026'
        ) : canLocate ? (
          'Select your local project folder to enable file sync'
        ) : (
          <>
            File sync requires the{' '}
            <Button
              size="small"
              onClick={() => setDialogOpen(true)}
              sx={{
                p: 0,
                minWidth: 0,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 'inherit',
                lineHeight: 'inherit',
                verticalAlign: 'baseline',
                textDecoration: 'underline',
                color: 'inherit',
                '&:hover': { backgroundColor: 'transparent', opacity: 0.8 },
              }}
            >
              Desktop app
            </Button>
            .
          </>
        )}
      </Alert>
      <DesktopAppRequiredDialog
        open={dialogOpen}
        action="fileSync"
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

export default ProjectFolderPrompt;
